<template>
  <h6>Персональные данные</h6>
  <div style="display: flex; justify-content: center">
    <div class="left-side" style="width: 50%; padding-right: 20px;">
      <label for="passportNumber" style="font-weight: bold;">Номер паспорта</label>
      <argon-input
          id="passportNumber"
          v-model="passport"
          :value="passport"
          @input="updateClientPassport"
          placeholder="Номер паспорта"
          :blurAction="() => {searchInBlackList(passport)}"
      />
      <div class="input-container">
        <label for="birthdate">Дата выдачи</label>
        <input
            id="passportIssueDate"
            v-model="passportIssueDate"
            type="date"
            placeholder="Дата выдачи"
            @input="updateClientPassportIssueDate"
        />
      </div>
      <div class="input-container" style=" margin-top: 16px; position: relative;">
        <label for="client">Орган выдавший паспорт</label>
        <input
            id="client"
            v-model="passportFilterAuthor"
            type="text"
            placeholder="Введите издателя"
            style="max-width: 100%; border: 1px solid #d2d6da; color: #495057; border-radius: 0.5rem; font-size: 0.85rem; padding: 0.5rem 0.75rem;"
            @input="filterPassportAuthor"
            @focus="showOptions = true"
            @blur="onBlurHandler"
        >
        <ul v-if="showOptions" class="options-list">
          <li @click="showPassportModal">
            Создать издателя
          </li>
          <li
              v-for="(author) in filteredPassportAuthors"
              :key="author.id"
              @click="updateClientPassportIssuingAuthorityId(author)"
          >
            {{ author.name }}
          </li>
        </ul>
      </div>
      <div class="input-container" style="margin-top: 16px;">
        <label for="imageUpload">Скан паспорта</label>
        <input ref="fileInput"
               style="display: none" type="file" id="imageUpload" @change="previewImage"
               accept="image/*">

        <argon-button
            v-if="passportScan === null"
            variant="inline"
            color="primary"
            type="button"
            @click="uploadFile"
        >Загрузить скан
        </argon-button>
      </div>

      <div v-if="passportScan" class="input-container" style="margin-top: 16px;">
        <div style="width: 200px; height: 100px; overflow: hidden; position: relative">
          <img :src="passportScan" alt="Превью изображения" style="max-width: 100%; object-fit: cover;">
          <div @click="clearImage(true)"
               style=" color: white; position: absolute;  top: 0; right: 0; width: 20px; height: 20px; background: rgba(255, 255, 255, 0.2); border-radius: 50%; text-align: center; line-height: 20px; cursor: pointer;">
            &times;
          </div>
        </div>
      </div>
      <label for="registrationAddress" style="font-weight: bold; margin-top: 16px;">Адрес регистрации</label>
      <argon-input
          id="registrationAddress"
          v-model="registrationAddress"
          :value="registrationAddress"
          placeholder="Адрес регистрации"
          @input="updateClientRegistrationAddress"
      />
      <label for="address" style="font-weight: bold;">Адрес проживания</label>
      <argon-input
          id="address"
          v-model="address"
          :value="address"
          placeholder="Адрес проживания"
          @input="updateClientAddress"
      />
    </div>
    <div class="right-side" style="width: 50%; padding-left: 20px;">

      <label for="email" style="font-weight: bold;">E-mail</label>
      <argon-input
          id="email"
          v-model="email"
          :value="email"
          placeholder="E-mail"
          @input="updateClientEmail"
      />
      <label for="phone" style="font-weight: bold;">Номер телефона</label>
      <argon-input
          id="phone"
          v-model="firstPhone"
          :value="firstPhone"
          placeholder="Номер телефона"
          @input="updateClientFirstPhone"
          :blurAction="() => searchInBlackList(firstPhone)"
      />
      <label for="additionalPhone" style="font-weight: bold;">Дополнительный номер телефона</label>
      <argon-input
          id="additionalPhone"
          v-model="secondPhone"
          :value="secondPhone"
          placeholder="Дополнительный номер телефона"
          @input="updateClientAdditionalPhone"
          :blurAction="() => searchInBlackList(secondPhone)"
      />

      <div class="text-warning text-sm" v-if="blackList.length > 0">НАЙДЕНЫ СОВПАДЕНИЯ ИЗ ЧЕРНОГО СПИСКА:
        <div v-for="(item, index) in blackList" :key="index">
          {{index + 1}}. {{item.client.fullName }} - {{item.reason}}
        </div>
      </div>


      <label for="workInfo" style="font-weight: bold; margin-top: 0.5rem;">Дополнительная информация</label>
      <argon-input
          id="workInfo"
          v-model="workInfo"
          :value="workInfo"
          placeholder="Дополнительная информация"
          @input="updateClientWorkInfo"
      />
    </div>
  </div>
</template>

<script>
import ArgonInput from "../../../components/ArgonInput.vue";
import axios from "@/axios";
import ArgonButton from "../../../components/ArgonButton.vue";

export default {
  name: 'ClientSecondStep',
  components: {ArgonButton, ArgonInput},
  data() {
    return {
      showOptions: false,
      blackList: [],
    };
  },
  computed: {

    filteredPassportAuthors() {
      if (!this.passportFilterAuthor || this.passportFilterAuthor.trim() === '') {
        return this.passportAuthors;
      } else {
        return this.passportAuthors.filter((author) =>
            author.name.toLowerCase().includes(this.passportFilterAuthor.toLowerCase())
        );
      }
    },


    firstPhone: {
      get() {
        return this.$store.state.clientCreateFirstPhone;
      },
    },

    address: {
      get() {
        return this.$store.state.clientCreateAddress;
      },
    },
    email: {
      get() {
        return this.$store.state.clientCreateEmail;
      },
    },
    secondPhone: {
      get() {
        return this.$store.state.clientCreateSecondPhone;
      },
    },
    passport: {
      get() {
        return this.$store.state.clientCreatePassport;
      },
    },
    registrationAddress: {
      get() {
        return this.$store.state.clientCreateRegistrationAddress;
      },
    },
    workInfo: {
      get() {
        return this.$store.state.clientCreateWorkInfo;
      },
    },
    passportIssueDate: {
      get() {
        return this.$store.state.clientCreatePassportIssueDate;
      },
    },
    passportIssuingAuthorityId: {
      get() {
        return this.$store.state.clientCreatePassportIssuingAuthorityId;
      },
    },
    passportScan: {
      get() {
        return this.$store.state.clientCreatePassportScan;
      },
    },
    isEditable: {
      get() {
        return this.$store.state.clientIsEditable;
      },
    },
    clientId: {
      get() {
        return this.$store.state.clientId;
      },
    },
    passportFilterAuthor: {
      get() {
        return this.$store.state.passportFilterAuthor;
      },
    },
    passportAuthors: {
      get() {
        return this.$store.state.passportAuthors;
      },
    },

  },
  methods: {

    searchInBlackList(number) {
      if(number != '') {
        let url = '/api/clients/get-blacklist?search=' + number;
        axios.get(url).then(response => {
          let list = response.data.data;
          this.blackList = list;
          console.log("Black: ", this.blackList);

        }).catch(error => {
          console.error("Ошибка загрузки данных: ", error);
        });
      }
      else {
        this.blackList = [];
      }
    },

    showPassportModal() {
      console.log("PASSPORT WORKS!");
      this.$store.commit('updatePassportModal', true);
    },

    filterPassportAuthor(payload) {
      this.$store.commit('updatePassportFilterAuthor', payload.target.value);
      this.showOptions = true;
    },
    updateClientFirstPhone(payload) {
      this.$store.commit('updateClientCreateFirstPhone', payload.target.value);
    },
    updateClientAddress(payload) {
      this.$store.commit('updateClientCreateAddress', payload.target.value);
    },
    updateClientEmail(payload) {
      this.$store.commit('updateClientCreateEmail', payload.target.value);
    },
    updateClientAdditionalPhone(payload) {
      this.$store.commit('updateClientCreateSecondPhone', payload.target.value);
    },
    updateClientPassport(payload) {
      this.$store.commit('updateClientCreatePassport', payload.target.value);
    },
    updateClientRegistrationAddress(payload) {
      this.$store.commit('updateClientCreateRegistrationAddress', payload.target.value);
    },
    updateClientWorkInfo(payload) {
      this.$store.commit('updateClientCreateWorkInfo', payload.target.value);
    },
    updateClientPassportIssueDate(payload) {
      this.$store.commit('updateClientPassportIssueDate', payload.target.value);
    },
    updateClientPassportIssuingAuthorityId(author) {
      this.$store.commit('updatePassportIssuingAuthorityId', author.id);
      this.$store.commit('updatePassportFilterAuthor', author.name);
      this.showOptions = false;
    },
    updateClientPassportScan(img) {
      this.$store.commit('updateClientPassportScan', img);
    },

    uploadFile() {
      this.$refs.fileInput.click();
    },

    onBlurHandler() {
      setTimeout(() => {
        this.showOptions = false;
      }, 200);
    },

    getPassportAuthorNameById(id) {
      for (let i = 0; i < this.passportAuthors.length; i++) {
        if (this.passportAuthors[i].id == id) {
          return this.passportAuthors[i].name;
        }
      }
      return 'Клиент не найден';
    },

    previewImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          this.updateClientPassportScan(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    clearImage(cleanRef) {
      this.updateClientPassportScan(null);
      if (cleanRef) {
        this.$refs.fileInput.value = null;
      }
    },
    fetchPassportScan() {
      axios.get('/api/clients/' + this.clientId + '/passport-scan').then(response => {
        let passport = "data:image/jpeg;base64," + response.data.passport_scan;
        this.updateClientPassportScan(passport);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
  },
  mounted() {
    if (this.passportScan != null && this.passportScan != "" && this.isEditable) {
      this.fetchPassportScan();
    }

  },
}
</script>

<style scoped>

#passportIssueDate {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  display: flex;
  flex-direction: column;
}

.options-list {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding-left: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.5rem;
  background-color: white;
  z-index: 1;
  top: 100%;
  margin-top: 0.25rem;
}

.options-list li {
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  list-style-type: none;
}

.options-list li:hover {
  background-color: #f8f9fa;
}

</style>
